import React, { useState } from "react";
import styled from "styled-components";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import Label from "../Label";

const InputWrapper = styled.div`
    position: relative;
    display: block;
`;

const Input = styled.input`
    border: 0;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    background-color: var(--white);
    padding: 10px 40px 10px 10px !important;
    width: 100%;
`;

const ToggleButton = styled.button.attrs({ type: "button" })`
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: transparent;
    border: 0;
    color: var(--gray-3);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px !important;

    &:hover {
        color: var(--gray-2);
    }
`;

const PasswordInput = (props) => {
    const { id, label, ...inputProps } = props;
    const [visible, setVisible] = useState(false);

    const toggle = () => setVisible((prev) => !prev);
    const ariaLabel = visible ? "Ocultar senha" : "Mostrar senha";

    return (
        <Label htmlFor={id}>
            <span>{label}</span>
            <InputWrapper>
                <Input
                    {...inputProps}
                    id={id}
                    type={visible ? "text" : "password"}
                />
                <ToggleButton
                    onClick={toggle}
                    aria-label={ariaLabel}
                    title={ariaLabel}
                >
                    {visible ? <FaEyeSlash /> : <FaEye />}
                </ToggleButton>
            </InputWrapper>
        </Label>
    );
};

export default PasswordInput;
